import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Typography } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { KeyInfo } from 'component/page/detail/DetailCard/KeyInfos/KeyInfo';
import ActivityOverview from 'component/page/detail/DetailCard/Overview/ActivityOverview';

export interface AtAGlanceSectionProps {
    isShowReadMoreButtonDisable: boolean;
}

const AtAGlanceSectionModular: React.FC<AtAGlanceSectionProps> = (props) => {
    const { isShowReadMoreButtonDisable } = props;
    const cms = useSelector(selectCmsFromBootstrap);

    return (
        <Card p="24" mb="16" variant="filled">
            <Typography variant="heading-l" mb="12">
                {cms[337252]}
            </Typography>
            <KeyInfo />
            <ActivityOverview isDisplayFullContent={isShowReadMoreButtonDisable} />
        </Card>
    );
};
AtAGlanceSectionModular.displayName = 'AtAGlanceSectionModular';

export default AtAGlanceSectionModular;
